var _path, _polygon, _line, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.341,20.128v9.852c0,.612-.354,1.168-.908,1.428h0c-5.343,2.505-11.523,2.505-16.866,0h0c-.554-.26-.908-.816-.908-1.428v-9.852"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.197 16.929 20.834 8.713 2.803 16.156 21.147 23.471 39.197 16.929"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.628,
    y1: 17.281,
    x2: 4.628,
    y2: 24.282
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.628,
    cy: 26.305,
    r: 1.825
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorClass);
export default __webpack_public_path__ + "static/media/indoor-class.df3ffe8b74697248ad45de950d54f1b3.svg";
export { ForwardRef as ReactComponent };